var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "show-transition" } }, [
    _vm.open
      ? _c(
          "div",
          { staticClass: "user-ratings" },
          [
            _c("img", {
              staticClass: "user-ratings__header-img",
              attrs: {
                src: require("./../../img/logos/holiday-check-logo.png"),
                alt: "Holiday Check"
              }
            }),
            _vm._v(" "),
            _vm._l(_vm.ratingsList, function(rating, ratingKey) {
              return _c(
                "div",
                { key: ratingKey, staticClass: "user-ratings__item" },
                [
                  _c("div", { staticClass: "user-ratings__item__icon" }, [
                    _c("img", { attrs: { src: rating.img, alt: "" } })
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("span", {
                      domProps: { textContent: _vm._s(rating.name) }
                    }),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "user-ratings__item__number",
                      domProps: { textContent: _vm._s(rating.value) }
                    })
                  ])
                ]
              )
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73b2ca0b", { render: render, staticRenderFns: staticRenderFns })
  }
}